import image1 from '../../../style/images/img-01.png'
import image2 from '../../../style/images/img-02.png'
import image3 from '../../../style/images/img-03.png'
import image4 from '../../../style/images/img-04.png'
import image5 from '../../../style/images/img-05.png'
import image6 from '../../../style/images/img-06.png'
import image7 from '../../../style/images/img-07.png'
import image8 from '../../../style/images/img-08.png'
import image9 from '../../../style/images/img-09.png'
import image1Mini from '../../../style/images/img-01-mini.png'
import image2Mini from '../../../style/images/img-02-mini.png'
import image3Mini from '../../../style/images/img-03-mini.png'
import image4Mini from '../../../style/images/img-04-mini.png'
import image5Mini from '../../../style/images/img-05-mini.png'
import image6Mini from '../../../style/images/img-06-mini.png'
import image7Mini from '../../../style/images/img-07-mini.png'
import image8Mini from '../../../style/images/img-08-mini.png'
import image9Mini from '../../../style/images/img-09-mini.png'

const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9]
const imagesMini = [image1Mini, image2Mini, image3Mini, image4Mini, image5Mini, image6Mini, image7Mini, image8Mini, image9Mini]

export {images, imagesMini}
